<template>
  <div
    :class="bem({
      hasBadge: !!banner.badge
    })"
  >
    <div :class="bem('media-wrapper')">
      <DatoCmsImage
        :class="bem('media', { desktop: true, showOnMobile: !banner.mobileMedia })"
        :data="banner.media.responsiveImage"
        object-fit="cover"
        :object-position="`${banner.media.focalPoint.x * 100}% ${
          banner.media.focalPoint.y * 100
        }%`"
        sizes="90vw"
      />
      
      <DatoCmsImage
        v-if="banner.mobileMedia"
        :class="bem('media', { mobile: true })"
        :data="banner.mobileMedia.responsiveImage"
        object-fit="cover"
        :object-position="`${banner.mobileMedia.focalPoint.x * 100}% ${
          banner.mobileMedia.focalPoint.y * 100
        }%`"
        sizes="90vw"
      />

      <div
        v-if="banner.badge"
        :class="bem('badge-wrapper')"
      >
        <DatoCmsImage
          :class="bem('badge')"
          :style="{ aspectRatio: banner.badge.responsiveImage.aspectRatio }"
          :data="banner.badge.responsiveImage"
          sizes="200px"
        />
      </div>
    </div>

    <div
      v-if="banner.content"
      :class="bem('content-wrapper')"
    >
      <GenericStructuredText
        :content="banner.content"
        copy-size="body"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Image as DatoCmsImage, type ResponsiveImageType } from 'vue-datocms'

const bem = useBEM('FilterPageBanner')

interface CampaignBanner {
  media: {
    responsiveImage: ResponsiveImageType
    focalPoint: { x: number, y: number }
  }
  mobileMedia?: {
    responsiveImage: ResponsiveImageType
    focalPoint: { x: number, y: number }
  }
  badge: { responsiveImage: ResponsiveImageType }
  content: {
    copy: object
  }
}

defineProps({
  banner: {
    type: Object as PropType<CampaignBanner>,
    required: true
  }
})
</script>

<style scoped lang="postcss">
.FilterPageBanner {
  @apply relative
    flex
    min-h-[135px] md:min-h-[225px];

  &--has-badge {
    @apply mb-[2.5rem] md:mb-[4rem];
  }
}

.FilterPageBanner__media-wrapper {
  @apply absolute inset-0;
}

.FilterPageBanner__badge-wrapper {
  /* Positioned bottom centre of banner, overlapping by 50% */
  @apply absolute
    bottom-0
    left-1/2
    transform
    -translate-x-1/2
    translate-y-1/2
    z-10;
}

.FilterPageBanner__badge {
  @apply h-[50px] md:h-[80px];
}

.FilterPageBanner__media {
  @apply w-full
    object-cover
    object-center
    absolute
    top-0
    left-0
    z-0
    rounded-lg
    h-full
    !max-w-none;

  &--desktop {
    @apply mdMax:!hidden md:block;

    &.FilterPageBanner__media--show-on-mobile {
      @apply !block;
    }
  }

  &--mobile {
    @apply mdMax:block md:!hidden;
  }
}

.FilterPageBanner__content-wrapper {
  @apply relative w-full self-stretch
    px-sm py-xs md:px-lg md:py-sm;
}
</style>